export const trimMetadata = {
  characterLength: {
    uniqueTrim: 255,
    trim: 255,
    costUom: 1,
    transmission: 255,
    driveTrain: 175,
    engineCylinderConfig: 25,
    engineCylinders: 11,
    horsePower: 11,
    fuelType: 255,
    fuelEffUom: 50,
    cabType: 100,
    msrPrice: 30,
    invoicePrice: 30,
    destinationCharge: 30,
    engineDisplacement: 6,
    engineDisplacementUom: 4,
    highwayFuelEff: 6,
    cityFuelEff: 6,
    doors: 1
  },
  numerics: [
    "invoicePrice",
    "msrPrice",
    "destinationCharge",
    "engineDisplacement",
    "engineCylinders",
    "highwayFuelEff",
    "cityFuelEff",
    "doors",
    "horsePower"
  ],
  length(field: string, fallback = 0): number {
    return this.characterLength[field] ?? fallback;
  },
  isNumeric(field: string): boolean {
    return this.numerics.includes(field);
  }
};

export const modelMetadata = {
  characterLength: {
    year: 4,
    make: 50,
    model: 50,
    bodyStyle: 50
  },
  numerics: ["year"],
  length(field: string, fallback = 0): number {
    return this.characterLength[field] ?? fallback;
  },
  isNumeric(field: string): boolean {
    return this.numerics.includes(field);
  }
};
